import { range } from 'lodash';
import { RangeSelect } from '../../types/common/form';
import { setNumberWithComma } from '../common';

export const makeRangeSelectList = (info: RangeSelect, suffix?: string) => {
  return range(info.count).map((item, index) => {
    const targetValue = info.min + index * info.step;
    return {
      id: targetValue,
      name: setNumberWithComma(targetValue, suffix),
    };
  });
};
